import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const initialState = {
  meetings: [],
  loadingMeetings: true,
  currentAppointment: null,
  appointmentToBeCancelled: null,
};

const meetingModule = {
  namespaced: true,

  state: initialState,
  mutations,
  actions,
  getters,
};

export default meetingModule;
